<template>
  <div>
    <b-modal
      id="historicoAlteracaoList"
      ref="historicoAlteracaoList"
      button-size="sm"
      no-close-on-backdrop
      no-stacking
      ok-only
      ok-title="Ok"
      cancel-title=""
      :cancel-disabled="true"
      cancel-variant="false"
      modal-class="modal-historico-alteracoes"
      scrollable
    >
      <div slot="modal-title">
        <h5>{{ 'Histórico de Alterações - ' + empresa.razaoSocial }}</h5>
        <fieldset class="font-weight-bold text-muted">
          Histórico de alterações da empresa
        </fieldset>
      </div>
      <visualizacao
        :historico="historicoOrdenado"
      />
    </b-modal>
  </div>
</template>

<style lang="scss">
.modal:nth-of-type(even) {
  z-index: 1052 !important;
}
.modal-backdrop.show:nth-of-type(even) {
  z-index: 1051 !important;
}

.modal-historico-alteracoes .modal-dialog {
  max-width: 1200px;
}

.modal-historico-alteracoes .modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
</style>

<script>
import HistoricoAlteracoesService from './services/HistoricoAlteracoesService'

export default {
  name: 'HistoricoAlteracaoView',
  components: {
    Visualizacao: () => import('./components/Visualizacao.vue'),
  },
  props: {
    empresa: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      historico: [],
    }
  },
  computed: {
    /**
     * Ordena o histórico por data decrescente (mais recentes primeiro).
     */
    historicoOrdenado() {
      return [...this.historico].sort((a, b) => {
        const dataA = new Date(a.data)
        const dataB = new Date(b.data)
        return dataB - dataA
      })
    },
  },
  methods: {
    show() {
      this.carregarHistorico()
      this.$refs.historicoAlteracaoList.show()
    },
    carregarHistorico() {
      if (this.empresa && this.empresa.id) {
        HistoricoAlteracoesService.obterHistorico(this.empresa.id)
          .then(response => {
            this.historico = response.data || []
          })
          .catch(() => {
            this.historico = []
          })
      }
    },
  },
}
</script>
